module.exports = __webpack_public_path__ + "static/media/country_ru.ecbc5b27.webp";